import { en } from "vuetify/locale";

export default {
    ...en,

    "alert": "Attention",
    "add": "Add",
    "back": "Back",
    "cancel": "Cancel",
    "clear": "Clear",
    "close": "Close",
    "confirm": "Confirm",
    "next": "Next",
    "save": "Save",
    "send_email": "Send",
    "help_country_code": "Country Code",
    "help_search_country": "Search a country",
    "help_mobile_number": "Mobile Number",
    "help_example": "Example",
    "earned": "Accumulated",
    "info": "Info",
    "ingredients": "Ingredients",
    "info_nutritional": "Nutritional Information",
    "remove": "Remove",
    "removeall": "Remove All",

    "campaigns": "Campaigns",
    "highlights": "Highlights",
    "home": "Home",
    "items": "Items",
    "map": "Map",
    "address": "Address",
    "settings": "Settings",
    "store": "Store",
    "stores": "Find Us",
    "support": "Support",
    "user": "Profile",
    "offers": "Offers",
    "qrcode": "QRCode",
    "transactions": "Movements",

    "generic_error": "Information not available at the moment",
    "mandatory": "Mandatory",
    "missing": "Missing",
    "no_movements_to_display": "No movements have been made yet",
    "phone_number": "Mobile Phone",
    "points": "Points",
    "qrcode_show_message": "Show this code at the Store",
    "stores_not_available": "No Stores Available",
    "total": "Total",
    "thank_you": "Thank you!",
    "transactions_detail": "Detail",
    "user_profile_updated_success": "User Profile Updated Successfully",
    "user_welcome": "Hi",

    "id_document": "Number",
    "id_document_type": "Identification Document",

    "profile": {
        "birth_date": "Birth Date",
        "birth_date_required": "Birth Date is required",
        "birth_date_minors": "Invalid date of birth, minors are excluded",
        "citizen_card_size": "Must have 12 digits",
        "communication_preferences": "Communication Preferences",
        "email_required": "E-mail is required",
        "email_invalid": "E-mail must be valid",
        "favourite_store": "Favourite Store",
        "gender": "Gender",
        "gender_male": "Male",
        "gender_female": "Female",
        "gender_other": "Other",
        "gender_required": "Gender is required",
        "id_document_required": "Identification Document Number required",
        "id_document_type_empty": "You must select the type of document",
        "identity_card_size": "Must have 9 digits",
        "name": "Name",
        "name_invalid": "Name must be less than 20 characters",
        "name_invalid_two_names": "First and Last Name",
        "name_required": "Name is required",
        "number_invalid": "Invalid Number",
        "passport_size": "Must have 8 digits",
        "phone_number_required": "Mobile Phone is required",
        "phone_nine_digits": "Mobile Phone must be 9 digits",
        "tax_number": "Tax Number",
        "tax_number_nine_digits": "Tax Number must be 9 digits",
        "tax_number_invalid": "Tax Number Invalid"
    },

    "gdpr_agreement": {
        "agreement_mandatory": "You must agree to continue.",
        "agreement_communication_means_mandatory": "To continue you must accept a mean of communication.",
        "gdpr_agreement": "Terms and Conditions",
        "gdpr_agreement_accept": "I have read and accept the Terms and Conditions, as well as the Protection of Personal Data.",
        "gdpr_agreement_agree": "Agree",
        "gdpr_agreement_disagree": "Disagree",
        "program_terms_policy": "General Conditions Loyalty Program",
        "terms_policy": "Terms, Conditions and Privacy Policies",
        "gdpr_agreement_revoke": "Consent to register personal data has been successfully revoked. Your data will be deleted."
    },

    "authentication": {
        "login_error": "It was not possible to validate the indicated user and code. Please try again.",
        "end_session": "Session Terminated",
        "login_step_user_title": "Enter your mobile phone number",
        "login_step_user_subtitle": "If you are not registered yet, we will send you an SMS with a code to complete your registration.",
        "login_step_password_title": "Enter your access code",
        "login_step_newuser_password_subtitle": "Check the access code in the SMS sent to you. This code is required to authenticate again. You can change it in your profile after completing your registration.",
        "logout": "Logout",
        "new_register": "New Register",
        "new_user": "New User",
        "register_now": "Register Now",
        "password": "Access Code",
        "password_change": "Change Access Code",
        "password_old": "Old Access Code",
        "password_new": "New Access Code",
        "password_new_success_sent": "New access code successfully sent to your mobile phone",
        "password_bigger_than8": "Must have at least 8 characters long",
        "password_bigger_than10": "Must have at least 10 characters long",
        "password_lower_case": "Must include at least one lower case letter",
        "password_one_number": "Must include at least one digit",
        "password_special_char": "Must include a special character",
        "password_upper_case": "Must include at least one upper case letter",
        "password_recover": "Send new Access Code",
        "password_required": "Access Code is required",
        "username_nine_digits": "Mobile Phone must be 9 digits",
        "phone_number_invalid": "Mobile Phone Invalid",
        "password_change_success": "Access Code changed successfully"
    },

    "vouchers": {
        "vouchers": "Vouchers",
        "voucher_due_date": "Due Date",
        "voucher_available_at": "Valid On",
        "voucher_emitted": "Emitted Voucher",
        "voucher_offers": "Vouchers & Offers",
        "voucher_rescued": "Rescued Voucher"
    },

    "shop": {
        "shop_cart": "Basket",
        "shop_cart_pay": "Payment",
        "shop_cart_checkout": "Next",
        "shop_cart_submit": "Checkout",
        "shop_cart_items": "Items Basket",
        "shop_cart_empty": "Your basket is empty",
        "shop_cart_items_unavailable": "Some items in the cart are currently unavailable.",
        "shop_item_added_to_cart": "Item successfully added to the shopping cart",
        "shop_item_remove_from_cart": "Item successfully removed from the shopping cart",
        "shop_item_stock": "Available",
        "shop_item_nostock": "No Stock",
        "order_successfully_submited": "Order successfully submitted",
        "buy": "Buy",
        "payment_method": "Payment Method",
        "shipping_costs": "Delivery Costs",
        "shipping_method": "Delivery Option",
        "shipping_location": "Pickup Location",
        "my_orders": "My Orders",
        "catalog": "Store",
        "order_resume_comments": "Comments",
        "order_resume_choose_date": "Choose Date",
        "delivery_options": "Delivery Options",
        "delivery_not_available": "Delivery Options Not Available",
        "order_resume": "Checkout Summary",
        "order_pay": "Payment",
        "order_payment_entity": "Payment Entity",
        "order_payment_reference": "Payment Reference",
        "order_payment_value": "Payment Amount",
        "order_payment_success": "Payment Successfully Verified",
        "order_payment_pending": "Awaiting Payment Validation",
        "order_payment_error": "Unable to Validate Payment",
        "order_complete": "Order Completed Successfully!",
        "exceeded_daily_orders": "Maximum allowed daily order request limit exceeded",
        "item_details_view": "Details",
        "item_define_menu": "My Menu",
        "item_define_menu_extra": "Options",
        "remember_orders_in_progress": "Check your order's status",
        "remember_shop_cart": "Your shopping cart is waiting",
        "promo_valid_until": "Promotion valid until"
    },

    "id_document_types": {
        "citizen_card": "Citizen Card",
        "identity_card": "Identity Card",
        "passport": "Passport",
        "residence_permit": "Residence Permit"
    }
}
